import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { TestPackagesStrip } from "@/components/TestPackagesStrip";
import { Differentiator } from "@/components/Differentiator";
import { ReportsShowcase } from "@/components/ReportsShowcase";
import { TestPicker } from "@/components/TestPicker";
import { Pricing } from "@/components/Pricing";
import { TestComparison } from "@/components/TestComparison";
import { HowItWorks } from "@/components/HowItWorks";
import { WaterProblems } from "@/components/WaterProblems";
import { Testimonials } from "@/components/Testimonials";
import { ServiceAreas } from "@/components/ServiceAreas";
import { QualityAssurance } from "@/components/QualityAssurance";
import { FinalCTA } from "@/components/FinalCTA";
import { Footer } from "@/components/Footer";
import { FAQ } from "@/components/FAQ";
import { SchemaJsonLd, localBusinessSchema, organizationSchema, websiteSchema, faqSchema } from "@/lib/seo";
import { GLOBAL_FAQS } from "@/lib/faqs";
import { useSEO, SEO_DEFAULTS } from "@/lib/useSEO";

export default function Home() {
  useSEO({
    title: "Tank & Bore Water Testing Australia | Aware Water Testing",
    description:
      "Professional tank and bore water testing Australia-wide. Local drop-off in Noosaville plus posted sample kits. E. coli, coliforms, pH, minerals and more.",
    // Jun 2026 SEO audit — the sitemap emits the homepage as
    // `https://awarewatertesting.com.au/`, so the canonical must match it
    // byte-for-byte. A slash-less variant is a self-referencing mismatch.
    url: `${SEO_DEFAULTS.baseUrl}/`,
  });
  return (
    <div className="min-h-screen bg-white text-slate-900">
      <SchemaJsonLd data={organizationSchema()} id="jsonld-organization" />
      <SchemaJsonLd data={websiteSchema()} id="jsonld-website" />
      <SchemaJsonLd data={localBusinessSchema()} id="jsonld-localbusiness" />
      <SchemaJsonLd data={faqSchema(GLOBAL_FAQS)} id="jsonld-faq" />
      <Header />
      <main>
        <Hero />
        <TestPackagesStrip />
        {/* Aware Feb-2026 — the "Do we service your area?" inline
            widget was removed from the homepage. Aware operates as a
            national posted-kit service, so we no longer ask visitors
            to check their suburb before proceeding to book. */}
        <Differentiator />
        {/* Anchor wrappers below let the homepage-only Header nav scroll to
            the right section. ReportsShowcase already exposes id="reports"
            internally, so it's anchor-targetable without an extra wrapper. */}
        <ReportsShowcase />
        <div id="water-tests" className="scroll-mt-20">
          <TestPicker />
          <Pricing />
          <TestComparison />
        </div>
        <div id="how-it-works" className="scroll-mt-20">
          <HowItWorks />
        </div>
        <WaterProblems />
        <Testimonials />
        <QualityAssurance />
        <ServiceAreas />
        <div id="faq" className="scroll-mt-20">
          <FAQ qas={GLOBAL_FAQS} />
        </div>
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
